import { useSyncExternalStore } from "react";
import { write } from "Service/storage";
import { THEME_STORAGE_KEY } from "Shared/Constants/storage";

export type Theme = "light" | "dark";

/**
 * The current theme, from `data-theme` on <html>. An inline script in
 * public/index.html sets it from storage before the bundle loads, so it is
 * right on the first paint; dark is the default.
 */
export const getTheme = (): Theme =>
  document.documentElement.getAttribute("data-theme") === "light"
    ? "light"
    : "dark";

export const setTheme = (theme: Theme) => {
  write(THEME_STORAGE_KEY, theme);
  document.documentElement.setAttribute("data-theme", theme);
};

export const toggleTheme = () =>
  setTheme(getTheme() === "dark" ? "light" : "dark");

const subscribe = (onChange: () => void) => {
  const observer = new MutationObserver(onChange);
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["data-theme"],
  });
  return () => observer.disconnect();
};

/** The current theme; re-renders when it is toggled. */
export const useTheme = () => useSyncExternalStore(subscribe, getTheme);
